import { Injectable } from '@angular/core';

/**
 * Pomocné nástroje pro práci s datem.
**/
@Injectable({
  providedIn: 'root'
})
export class DateUtils {

  /**
   * Přidá zadaný počet dní k předanému datu. Pokud je počet dní záporný, tak je odečte.
   * @param datum
   * @param pocetDni
   */
  addDays(datum: Date, pocetDni: number): Date {
    if (datum == void 0) {
      return undefined;
    }
    else if (pocetDni == void 0 || pocetDni == 0) {
      return datum;
    }

    datum.setDate(datum.getDate() + pocetDni);
    return datum;
  }


  /**
   * Vrátí datum s vynulovanou časovou složkou.
   * @param datum
   */
  getDateWithoutTime(datum: Date): Date {
    return new Date(datum.setHours(0, 0, 0, 0));
  }
}
